/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef, useContext } from "react";
import EntradasDB from "../firebase/EntradasDB";
import CabeceraInDB from "../firebase/CabeceraInDB";
import Alertas from "./Alertas";
import validarRut from "../funciones/validarRut";
import { auth, db } from "../firebase/firebaseConfig";
import {
    getDocs,
    getDoc,
    collection,
    where,
    query,
    updateDoc,
    doc,
    writeBatch,
    deleteDoc,
} from "firebase/firestore";
import { TipDoc, TipoIn } from "./TipDoc";
import moment from "moment";
import { UserContext } from "../context/UserContext";
import {
    ConfirmaModal,  
    Overlay,
} from "../elementos/General";
import {
    Table,
    Container,
    Segment,
    Header,
    Form,
    Icon,
    Button,
    Dropdown,
    Input,
    Label,
} from "semantic-ui-react";
import Swal from "sweetalert2";
import Spinner from "./Spinner";
import BuscadorInput from "./BuscadorInput";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";

import { PDFViewer } from "@react-pdf/renderer";
import DocumentoEntradaPDF from "./DocumentoEntradaPDF";

import subirArchivo from '../funciones/subirArchivos';

const Entradas = () => {
    const user = auth.currentUser;
    const { users } = useContext(UserContext);

    const fechaAdd = new Date();
    const fechaMod = new Date();

    const fechaMinima = new Date();
    fechaMinima.setDate(fechaAdd.getDate() - 1);

    const fechaMaxima = new Date();
    fechaMaxima.setDate(fechaAdd.getDate() + 1);

    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [alerta, cambiarAlerta] = useState({});

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showConfirmationAnular, setShowConfirmationAnular] = useState(false);
    const [showConfirmarDocumento, setShowConfirmarDocumento] = useState(false);
    const [modalBuscarEquipo, setModalBuscarEquipo] = useState(false);
    const [equiposPreparacion, setEquiposPreparacion] = useState([]);
    const [textoFiltroEquipo, setTextoFiltroEquipo] = useState("");
    const [cargandoEquiposPrep, setCargandoEquiposPrep] = useState(false);
    const [modalPDF, setModalPDF] = useState(false);
    const [cabeceraPDF, setCabeceraPDF] = useState(null);
    const [detallePDF, setDetallePDF] = useState([]);
    const [cargandoPDFId, setCargandoPDFId] = useState(null);
    const [itemDelete, setItemdelete] = useState(false);
    const [itemAnular, setItemAnular] = useState(false);
    const [cabecera, setCabecera] = useState([]);
    const [dataEntrada, setDataEntrada] = useState([]);
    const [empresa, setEmpresa] = useState([]);
    const [status, setStatus] = useState([]);
    const [protocolo, setProtocolo] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [ultimosConfirmados, setUltimosConfirmados] = useState([]);
    const [numDoc, setNumDoc] = useState("");
    const [nomTipDoc, setNomTipDoc] = useState("");
    const [date, setDate] = useState(new Date());
    const [nomTipoIn, setNomTipoIn] = useState("");
    const [rut, setRut] = useState("");
    const [entidad, setEntidad] = useState("");
    const [numSerie, setNumSerie] = useState("");
    const [price, setPrice] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [flag, setFlag] = useState(false);
    const [flag2, setFlag2] = useState(false);
    const [confirmar, setConfirmar] = useState(false);
    const [btnGuardar, setBtnGuardar] = useState(false);
    const [btnAgregar, setBtnAgregar] = useState(true);
    const [btnConfirmar, setBtnConfirmar] = useState(false);
    const [btnNuevo, setBtnNuevo] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [guardandoCabecera, setGuardandoCabecera] = useState(false);
    const [guardandoDetalle, setGuardandoDetalle] = useState(false);
    const [confirmandoDocumento, setConfirmandoDocumento] = useState(false);
    const [cabeceraMinimizada, setCabeceraMinimizada] = useState(false);
    const [detalleMinimizado, setDetalleMinimizado] = useState(true);
    const [ultimoItemAgregadoId, setUltimoItemAgregadoId] = useState(null);
    const [archivoAdjunto, setArchivoAdjunto] = useState(null);
    const [modalArchivo, setModalArchivo] = useState(false);
    const [urlArchivoModal, setUrlArchivoModal] = useState('');
    const [seccionActiva, setSeccionActiva] = useState("CABECERA");

    // ID exacto de la cabecera actualmente en proceso
    const [cabeceraId, setCabeceraId] = useState(null);

    const almacenar = useRef([]);
    const entradaid = useRef([]);
    const detalleTablaRef = useRef(null);
    const inputArchivoRef = useRef(null);

    const precioValido = Number(price) > 0;

    // Función para esperar un tiempo determinado (en milisegundos)
    const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const mostrarError = (mensaje) => {
        cambiarEstadoAlerta(true);
        cambiarAlerta({ tipo: "error", mensaje });
    };

    const mostrarExito = (mensaje) => {
        cambiarEstadoAlerta(true);
        cambiarAlerta({ tipo: "exito", mensaje });
    };

    const formatearMiles = (valor) => {
        if (!valor) return "";
        return Number(valor).toLocaleString("es-CL");
    };

    const limpiarNumero = (valor) => {
        return valor.replace(/\./g, "");
    };

    const OrdenaFecha = (a, b) => {
        return (a.fechaadd?.seconds || 0) - (b.fechaadd?.seconds || 0);
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return "";
        const dateObj = fecha.toDate ? fecha.toDate() : new Date(fecha);
        return moment(dateObj).format("DD/MM/YYYY HH:mm");
    };

    const fechaDate = (fecha) => {
        if (!fecha) return;

        if (fecha.toDate) {
            setDate(fecha.toDate());
        } else {
            setDate(new Date(fecha));
        }
    };

    const sumarDias = (fecha, dias) => {
        const nuevaFecha = new Date(fecha);
        nuevaFecha.setDate(nuevaFecha.getDate() + dias);
        return nuevaFecha;
    };

    const consultarCab = async () => {
        if (!users) return;

        const q = query(
            collection(db, "entradasCab"),
            where("emp_id", "==", users.emp_id),
            where("confirmado", "==", false),
            where("tipmov", "==", 1)
        );

        const snap = await getDocs(q);

        setCabecera(
            snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }))
        );
    };

    const consultarUltimosConfirmados = async () => {
        if (!users) return;

        try {
            const q = query(
                collection(db, "entradasCab"),
                where("emp_id", "==", users.emp_id),
                where("confirmado", "==", true),
                where("tipmov", "==", 1)
            );

            const snap = await getDocs(q);

            const docs = snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }));

            const ordenados = docs
                .sort((a, b) => {
                    const fechaA =
                        a.fechamod?.seconds ||
                        a.fechaMod?.seconds ||
                        a.fechaadd?.seconds ||
                        a.fechaAdd?.seconds ||
                        a.date?.seconds ||
                        0;

                    const fechaB =
                        b.fechamod?.seconds ||
                        b.fechaMod?.seconds ||
                        b.fechaadd?.seconds ||
                        b.fechaAdd?.seconds ||
                        b.date?.seconds ||
                        0;

                    return fechaB - fechaA;
                })
                .slice(0, 5);

            setUltimosConfirmados(ordenados);
        } catch (error) {
            console.log("Error al consultar últimos confirmados:", error);
            setUltimosConfirmados([]);
        }
    };

    const consultarIn = async () => {
        if (!users?.emp_id) return;

        // Sin una cabecera exacta no buscamos detalle.
        if (!cabeceraId) {
            setDataEntrada([]);
            return;
        }

        try {
            const q = query(
                collection(db, "entradas"),
                where("emp_id", "==", users.emp_id),
                where("cab_id", "==", cabeceraId)
            );

            const snap = await getDocs(q);

            const docs = snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }));

            setDataEntrada(docs.sort(OrdenaFecha));
        } catch (error) {
            console.error("Error al consultar detalle de entrada:", error);
            setDataEntrada([]);
            mostrarError("Error al consultar detalle del documento");
        }
    };

    const consultarCabProt = async () => {
        if (!users) return;

        const q = query(
            collection(db, "protocoloscab"),
            where("emp_id", "==", users.emp_id)
        );

        const snap = await getDocs(q);

        setProtocolo(
            snap.docs.map((docu) => ({
                ...docu.data(),
                id: docu.id,
            }))
        );
    };

    const getEmpresa = async () => {
        if (!users) return;

        const traerEmp = await getDoc(doc(db, "empresas", users.emp_id));
        setEmpresa(traerEmp.data());
    };

    const consultarProv = async () => {
        if (!users) return;

        const q = query(
            collection(db, "proveedores"),
            where("emp_id", "==", users.emp_id)
        );

        const snap = await getDocs(q);

        setProveedores(
            snap.docs.map((docu) => ({
                ...docu.data(),
                id: docu.id,
            }))
        );
    };

    const getStatus = async () => {
        if (!users) return;

        const q = query(
            collection(db, "status"),
            where("emp_id", "==", users.emp_id)
        );

        const snap = await getDocs(q);

        setStatus(
            snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }))
        );
    };

    const obtenerDetalleDocumento = async (cabId) => {
        const q = query(
            collection(db, "entradas"),
            where("emp_id", "==", users.emp_id),
            where("cab_id", "==", cabId)
        );

        const snap = await getDocs(q);

        return snap.docs.map((docu, index) => ({
            ...docu.data(),
            id: docu.id,
            id2: index + 1,
        }));
    };

    const verPDFDocumento = async (cab) => {
        setCargandoPDFId(cab.id);

        try {
            const detalle = await obtenerDetalleDocumento(cab.id);

            setCabeceraPDF(cab);
            setDetallePDF(detalle);
            setModalPDF(true);
        } catch (error) {
            mostrarError("Error al cargar PDF");
        } finally {
            setCargandoPDFId(null);
        }
    };

    const handleSelectItem = (item) => {
        const isObject = item !== null && typeof item === "object";

        if (isObject) {
            setRut(item.rut);
            setEntidad(item.nombre);
            return;
        }

        const expresionRegularRut = /^[0-9]+[-|‐]{1}[0-9kK]{1}$/;
        const temp = item.split("-");
        let digito = temp[1];

        if (digito === "k" || digito === "K") digito = -1;

        const validaR = validarRut(item);

        if (item === "") {
            mostrarError("Favor ingresa un rut");
            return;
        }

        if (!expresionRegularRut.test(item)) {
            mostrarError("Formato incorrecto de rut");
            return;
        }

        if (validaR !== parseInt(digito)) {
            mostrarError("Rut no válido");
            return;
        }

        mostrarError("No existe rut de proveedor");
    };

    const limpiaFormCte = () => {
        setRut("");
        setEntidad("");
        setArchivoAdjunto(null);

        if (inputArchivoRef.current) {
            inputArchivoRef.current.value = '';
        }
    };

    const obtenerEquipoPorSerieOId = async (serieBuscada) => {
        const qSerie = query(
            collection(db, "equipos"),
            where("emp_id", "==", users.emp_id),
            where("serie", "==", serieBuscada)
        );

        const snapSerie = await getDocs(qSerie);

        const existe = snapSerie.docs.map((docu) => ({
            ...docu.data(),
            id: docu.id,
        }));

        if (existe.length === 1) return existe[0];

        const snapId = await getDoc(doc(db, "equipos", serieBuscada));

        if (snapId.exists()) {
            return {
                ...snapId.data(),
                id: serieBuscada,
            };
        }

        return null;
    };

    const validarEquipoRecepcion = async (equipoFinal) => {
        if (!equipoFinal) {
            mostrarError("No hay equipo seleccionado o detectado");
            return false;
        }

        const estadoEquipo = status.find((st) => st.id === equipoFinal.id);

        if (!estadoEquipo) {
            mostrarError("El equipo no tiene estado asignado");
            return false;
        }

        if (estadoEquipo.status !== "PREPARACION") {
            mostrarError(
                `No se puede recepcionar. Estado actual: ${estadoEquipo.status}`
            );
            return false;
        }

        const existeEnDocumento = dataEntrada.filter(
            (docu) => docu.serie === equipoFinal.serie || docu.eq_id === equipoFinal.id
        );

        if (existeEnDocumento.length > 0) {
            mostrarError("Equipo ya se encuentra en este documento");
            return false;
        }

        const qSerieCompra = query(
            collection(db, "entradas"),
            where("emp_id", "==", users.emp_id),
            where("serie", "==", equipoFinal.serie || ""),
            where("tipoinout", "==", "COMPRA")
        );

        const snapSerieCompra = await getDocs(qSerieCompra);

        const qIdCompra = query(
            collection(db, "entradas"),
            where("emp_id", "==", users.emp_id),
            where("eq_id", "==", equipoFinal.id),
            where("tipoinout", "==", "COMPRA")
        );

        const snapIdCompra = await getDocs(qIdCompra);

        const qSeriePendiente = query(
            collection(db, "entradas"),
            where("emp_id", "==", users.emp_id),
            where("serie", "==", equipoFinal.serie || ""),
            where("confirmado", "==", false)
        );

        const snapSeriePendiente = await getDocs(qSeriePendiente);

        const qIdPendiente = query(
            collection(db, "entradas"),
            where("emp_id", "==", users.emp_id),
            where("eq_id", "==", equipoFinal.id),
            where("confirmado", "==", false)
        );

        const snapIdPendiente = await getDocs(qIdPendiente);

        if (!nomTipoIn || nomTipoIn === "COMPRA") {
            if (snapSerieCompra.docs.length > 0 || snapIdCompra.docs.length > 0) {
                mostrarError("Equipo ya se encuentra Ingresado como Compra");
                return false;
            }
        }

        if (snapSeriePendiente.docs.length > 0 || snapIdPendiente.docs.length > 0) {
            mostrarError("Equipo ya se encuentra Ingresado en un documento por confirmar");
            return false;
        }

        return true;
    };

    const addCabeceraIn = async (ev) => {
        ev.preventDefault();

        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        const expresionRegularRut = /^[0-9]+[-|‐]{1}[0-9kK]{1}$/;
        const temp = rut.split("-");
        let digito = temp[1];

        if (digito === "k" || digito === "K") digito = -1;

        const validaR = validarRut(rut);

        const qCab = query(
            collection(db, "entradasCab"),
            where("emp_id", "==", users.emp_id),
            where("numdoc", "==", numDoc),
            where("tipdoc", "==", nomTipDoc),
            where("rut", "==", rut),
            where("tipmov", "==", 1)
        );

        const snapCab = await getDocs(qCab);

        const existeCab = snapCab.docs.map((docu, index) => ({
            ...docu.data(),
            id: docu.id,
            id2: index + 1,
        }));

        if (numDoc === "") {
            mostrarError("Ingrese N° Documento");
            return;
        }

        if (nomTipDoc.length === 0 || nomTipDoc === "Selecciona Opción:") {
            mostrarError("Seleccione Tipo Documento");
            return;
        }

        if (!date) {
            mostrarError("Seleccione una Fecha");
            return;
        }

        if (nomTipoIn.length === 0 || nomTipoIn === "Selecciona Opción:") {
            mostrarError("Seleccione un Tipo de Entrada");
            return;
        }

        if (rut === "") {
            mostrarError("Campo Rut no puede estar vacío");
            return;
        }

        if (!expresionRegularRut.test(rut)) {
            mostrarError("Formato incorrecto de rut");
            return;
        }

        if (validaR !== parseInt(digito)) {
            mostrarError("Rut no válido");
            return;
        }

        if (existeCab.length > 0) {
            if (existeCab[0].confirmado) {
                mostrarError("Ya existe este documento y se encuentra confirmado");
            } else {
                mostrarError("Ya existe este documento. Falta confirmar");
            }
            return;
        }

        setCargando(true);
        setGuardandoCabecera(true);

        try {
            const cabeceraCreada = await CabeceraInDB({
                numDoc,
                tipDoc: nomTipDoc,
                date,
                tipoInOut: nomTipoIn,
                rut,
                entidad,
                descripcion,
                tipMov: 1,
                url: "",
                confirmado: false,
                observacion: "",
                userAdd: user.email,
                userMod: user.email,
                fechaAdd,
                fechaMod,
                emp_id: users.emp_id,
            });
            // Guardamos el ID exacto de la cabecera creada.
            // Desde este momento todo el detalle se asociará a este ID.
            setCabeceraId(cabeceraCreada.id);
            let urlArchivo = '';

            if (archivoAdjunto) {

                urlArchivo = await subirArchivo({
                    archivo: archivoAdjunto,
                    carpeta: 'entradas',
                    emp_id: users.emp_id,
                    documentoId: cabeceraCreada.id
                });

                await updateDoc(doc(db, "entradasCab", cabeceraCreada.id), {
                    urlAdjunto: urlArchivo,
                    nombreAdjunto: archivoAdjunto.name,
                });



            }
            mostrarExito("Cabecera guardada exitosamente. Ahora puede ingresar el detalle.");

            setFlag((prev) => !prev);

            setConfirmar(true);

            setBtnAgregar(false);
            setBtnGuardar(true);
            setBtnNuevo(false);

            setCabeceraMinimizada(true);
            setDetalleMinimizado(false);

            // Pasamos visualmente al detalle
            setSeccionActiva("DETALLE");
        } catch (error) {
            mostrarError("Error al guardar cabecera");
        } finally {
            await esperar(800);
            setCargando(false);
            setGuardandoCabecera(false);
        }
    };
    const handleSubmit = async (e, equipoSeleccionado = null) => {
        e?.preventDefault?.();

        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        if (!cabeceraId) {
            mostrarError(
                "No existe una cabecera activa para agregar el equipo"
            );
            return;
        }

        if (!precioValido) {
            mostrarError("Ingrese Precio de Equipo");
            return;
        }

        let equipoFinal =
            equipoSeleccionado || almacenar.current[0];

        if (!equipoFinal) {
            if (!numSerie) {
                mostrarError("Ingrese o Scaneé N° Serie");
                return;
            }

            equipoFinal = await obtenerEquipoPorSerieOId(
                numSerie.trim()
            );
        }

        if (!equipoFinal) {
            mostrarError(
                "No existe un Equipo con este N° Serie o Id"
            );
            return;
        }

        const valido = await validarEquipoRecepcion(
            equipoFinal
        );

        if (!valido) return;

        setGuardandoDetalle(true);

        try {
            await EntradasDB({
                numDoc,
                tipDoc: nomTipDoc,
                date,
                tipoInOut: nomTipoIn,
                rut,
                entidad,
                price: Number(price),

                // ID exacto de la cabecera actual
                cab_id: cabeceraId,

                eq_id: equipoFinal.id,
                familia: equipoFinal.familia || "",
                tipo: equipoFinal.tipo || "",
                marca: equipoFinal.marca || "",
                modelo: equipoFinal.modelo || "",
                serie: equipoFinal.serie || "",
                rfid: equipoFinal.rfid || "",
                tipMov: 1,
                observacion: "",
                historial: 1,
                confirmado: false,
                userAdd: user?.email || "",
                userMod: user?.email || "",
                fechaAdd,
                fechaMod,
                emp_id: users.emp_id,
            });

            setUltimoItemAgregadoId(equipoFinal.id);

            setPrice("");
            setNumSerie("");

            almacenar.current = [];
            entradaid.current = [];

            mostrarExito("Item guardado correctamente");

            setFlag((prev) => !prev);
            setBtnConfirmar(false);
            setBtnNuevo(false);

            setTimeout(() => {
                setUltimoItemAgregadoId(null);
            }, 3500);
        } catch (error) {
            console.error(
                "Error al guardar item de entrada:",
                error
            );

            mostrarError("Error al guardar item");
        } finally {
            await esperar(600);
            setGuardandoDetalle(false);
        }
    };

    const abrirBuscadorEquiposPreparacion = async () => {
        if (!users) return;

        if (!precioValido) {
            mostrarError("Ingrese un precio antes de seleccionar equipo");
            return;
        }

        setModalBuscarEquipo(true);
        setTextoFiltroEquipo("");
        setCargandoEquiposPrep(true);

        try {
            const idsPreparacion = status
                .filter((st) => st.status === "PREPARACION")
                .map((st) => st.id);

            const q = query(
                collection(db, "equipos"),
                where("emp_id", "==", users.emp_id)
            );

            const snap = await getDocs(q);

            const equipos = snap.docs
                .map((docu) => ({
                    ...docu.data(),
                    id: docu.id,
                }))
                .filter((eq) => idsPreparacion.includes(eq.id));

            setEquiposPreparacion(equipos);
        } catch (error) {
            mostrarError("Error al cargar equipos en preparación");
        } finally {
            setCargandoEquiposPrep(false);
        }
    };

    const equiposPreparacionFiltrados = equiposPreparacion.filter((eq) => {
        const texto = textoFiltroEquipo.toLowerCase().trim();

        if (texto === "") return true;

        return (
            eq.id?.toLowerCase().includes(texto) ||
            eq.serie?.toLowerCase().includes(texto) ||
            eq.familia?.toLowerCase().includes(texto) ||
            eq.tipo?.toLowerCase().includes(texto) ||
            eq.marca?.toLowerCase().includes(texto) ||
            eq.modelo?.toLowerCase().includes(texto) ||
            eq.rfid?.toLowerCase().includes(texto)
        );
    });

    const seleccionarEquipoPreparacion = async (equipo) => {
        setModalBuscarEquipo(false);
        setTextoFiltroEquipo("");
        setEquiposPreparacion([]);

        almacenar.current = [equipo];
        setNumSerie(equipo.serie || equipo.id);

        await handleSubmit({ preventDefault: () => { } }, equipo);
    };

    const actualizarDocs = async () => {
        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        if (!cabeceraId) {
            mostrarError(
                "No existe una cabecera activa para confirmar"
            );
            return;
        }

        if (dataEntrada.length === 0) {
            Swal.fire(
                "No hay Datos por confirmar en este documento"
            );
            return;
        }

        // =====================================================
        // COMPRA / ARRIENDO / COMODATO
        // =====================================================

        if (
            nomTipoIn === "COMPRA" ||
            nomTipoIn === "ARRIENDO" ||
            nomTipoIn === "COMODATO"
        ) {
            const batch = writeBatch(db);

            dataEntrada.forEach((docs) => {
                const statusRef = doc(
                    db,
                    "status",
                    docs.eq_id
                );

                batch.update(statusRef, {
                    status: "BODEGA",

                    r_origen: rut,
                    n_origen: entidad,

                    r_destino: empresa.rut,
                    n_destino: empresa.empresa,

                    // El precio pertenece al mismo detalle.
                    // No dependemos de índices entre arrays.
                    price: Number(docs.price || 0),

                    tipoinout: nomTipoIn,

                    fechamod: new Date(),
                });
            });

            dataEntrada.forEach((docs) => {
                const entradaRef = doc(
                    db,
                    "entradas",
                    docs.id
                );

                batch.update(entradaRef, {
                    confirmado: true,
                    fechamod: new Date(),
                });
            });

            await batch.commit();

            // =================================================
            // PLAN DE MANTENCIÓN PARA COMPRAS
            // =================================================

            if (nomTipoIn === "COMPRA") {
                const batchMantencion = writeBatch(db);
                const mantoRef = collection(
                    db,
                    "mantenciones"
                );

                let contar = 0;

                dataEntrada.forEach((docs) => {
                    protocolo.forEach((item) => {
                        if (docs.tipo === item.tipo) {
                            contar += 1;

                            const nuevoDocRef = doc(
                                mantoRef
                            );

                            batchMantencion.set(
                                nuevoDocRef,
                                {
                                    cab_id_protocol:
                                        item.id,

                                    nombre_protocolo:
                                        item.nombre,

                                    programa:
                                        item.programa,

                                    dias:
                                        item.dias,

                                    fecha_inicio:
                                        fechaAdd,

                                    fecha_termino:
                                        sumarDias(
                                            fechaAdd,
                                            item.dias
                                        ),

                                    // IMPORTANTE:
                                    // ID real del equipo
                                    id_eq:
                                        docs.eq_id,

                                    familia:
                                        docs.familia,

                                    tipo:
                                        docs.tipo,

                                    serie:
                                        docs.serie,

                                    emp_id:
                                        users.emp_id,

                                    activo: true,
                                    estado:
                                        "PENDIENTE",

                                    enproceso: "0",

                                    alerta_30_enviada:
                                        false,

                                    alerta_15_enviada:
                                        false,

                                    alerta_7_enviada:
                                        false,

                                    alerta_vencida_enviada:
                                        false,

                                    id_ingreso_st: "",
                                    folio_ingreso_st: "",

                                    origen:
                                        "INGRESO_EQUIPO",

                                    useradd:
                                        user?.email ||
                                        "",

                                    usermod:
                                        user?.email ||
                                        "",

                                    fechaadd:
                                        fechaAdd,

                                    fechamod:
                                        fechaMod,
                                }
                            );
                        }
                    });
                });

                if (contar > 0) {
                    await batchMantencion.commit();

                    Swal.fire(
                        "Se han agregado Equipos al Plan de Mantención"
                    );
                }
            }
        }

        // =====================================================
        // OTROS TIPOS DE ENTRADA
        // =====================================================

        else {
            const batch = writeBatch(db);

            dataEntrada.forEach((docs) => {
                const statusRef = doc(
                    db,
                    "status",
                    docs.eq_id
                );

                batch.update(statusRef, {
                    status: "BODEGA",

                    r_origen: rut,
                    n_origen: entidad,

                    r_destino: empresa.rut,
                    n_destino: empresa.empresa,

                    r_permanente: "",
                    n_permanente: "",
                    fecha_permanente: "",

                    fechamod: new Date(),
                });
            });

            dataEntrada.forEach((docs) => {
                const entradaRef = doc(
                    db,
                    "entradas",
                    docs.id
                );

                batch.update(entradaRef, {
                    confirmado: true,
                    fechamod: new Date(),
                    historial: 1,
                });
            });

            await batch.commit();
        }

        // =====================================================
        // CONFIRMAR CABECERA EXACTA
        // =====================================================

        await updateDoc(
            doc(
                db,
                "entradasCab",
                cabeceraId
            ),
            {
                confirmado: true,
                usermod: user?.email || "",
                fechamod: new Date(),
            }
        );

        mostrarExito(
            "Documento confirmado exitosamente."
        );

        // =====================================================
        // LIMPIAR PANTALLA
        // =====================================================

        setCabeceraId(null);

        setNomTipDoc("");
        setNumDoc("");
        setDate(new Date());
        setNomTipoIn("");

        setRut("");
        setEntidad("");

        setNumSerie("");
        setPrice("");
        setDescripcion("");

        setArchivoAdjunto(null);

        if (inputArchivoRef.current) {
            inputArchivoRef.current.value = "";
        }

        setConfirmar(false);

        setBtnConfirmar(true);
        setBtnAgregar(true);
        setBtnGuardar(false);
        setBtnNuevo(true);

        setCabeceraMinimizada(false);
        setDetalleMinimizado(true);
        // Documento terminado:
        // el próximo flujo comienza en cabecera
        setSeccionActiva("CABECERA");

        setDataEntrada([]);

        almacenar.current = [];
        entradaid.current = [];

        await consultarUltimosConfirmados();

        setFlag((prev) => !prev);
        setFlag2((prev) => !prev);
    };
    const confirmarDocumento = async () => {
        setShowConfirmarDocumento(false);
        setConfirmandoDocumento(true);
        setCargando(true);

        try {
            await actualizarDocs();
        } catch (error) {
            mostrarError("Error al confirmar documento");
        } finally {
            setConfirmandoDocumento(false);
            setCargando(false);
        }
    };

    const handleDelete = (itemId) => {
        setItemdelete(itemId);
        setShowConfirmation(true);
    };

    const borrarItem = async () => {
        if (itemDelete) {
            try {
                await deleteDoc(doc(db, "entradas", itemDelete));
                setFlag(!flag);
                mostrarExito("Item eliminado exitosamente.");
            } catch (error) {
                mostrarError("Error al eliminar item");
            }
        }

        setShowConfirmation(false);
    };

    const handleAnular = (itemId) => {
        setItemAnular(itemId);
        setShowConfirmationAnular(true);
    };

    const anular = async () => {
        const q = query(
            collection(db, "entradas"),
            where("cab_id", "==", itemAnular)
        );

        const snap = await getDocs(q);

        const detalle = snap.docs.map((docu) => ({
            ...docu.data(),
            id: docu.id,
        }));

        try {
            await updateDoc(doc(db, "entradasCab", itemAnular), {
                tipmov: 3,
                fechamod: fechaMod,
            });
        } catch (error) {
            Swal.fire("Error al Anular Documento");
        }

        if (detalle.length > 0) {
            const batch = writeBatch(db);

            detalle.forEach((docs) => {
                batch.delete(doc(db, "entradas", docs.id));
            });

            try {
                await batch.commit();
            } catch (error) {
                mostrarError("Error al borrar detalle");
            }
        }

        mostrarExito("Documento Anulado.");
        setCabeceraId(null);
        setNumDoc("");
        setNomTipDoc("");
        setDate(new Date());
        setNomTipoIn("");
        setRut("");
        setEntidad("");
        setDescripcion("");
        setArchivoAdjunto(null);
        if (inputArchivoRef.current) {
            inputArchivoRef.current.value = "";
        }
        setConfirmar(false);
        setBtnGuardar(false);
        setBtnAgregar(true);
        setBtnConfirmar(false);
        setBtnNuevo(true);
        setCabeceraMinimizada(false);
        setDetalleMinimizado(true);
        setDataEntrada([]);
        setFlag(!flag);
        setShowConfirmationAnular(false);
    };

    const nuevo = () => {
        setCabeceraId(null);

        setNumDoc("");
        setNomTipDoc("");

        // La fecha visible y la fecha real coinciden.
        setDate(new Date());

        setNomTipoIn("");

        setRut("");
        setEntidad("");

        setNumSerie("");
        setPrice("");
        setDescripcion("");

        setArchivoAdjunto(null);

        if (inputArchivoRef.current) {
            inputArchivoRef.current.value = "";
        }

        setConfirmar(false);
        setBtnGuardar(false);
        setBtnAgregar(true);
        setBtnConfirmar(false);
        setBtnNuevo(true);
        setCabeceraMinimizada(false);
        setDetalleMinimizado(true);
        // Volvemos visualmente a cabecera
        setSeccionActiva("CABECERA")
        setDataEntrada([]);
        setUltimoItemAgregadoId(null);
        almacenar.current = [];
        entradaid.current = [];
        setFlag((prev) => !prev);
    };

    useEffect(() => {
        getStatus();
        getEmpresa();
        consultarProv();
        consultarCab();
        consultarCabProt();
        consultarUltimosConfirmados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users]);

    useEffect(() => {
        getStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flag2, users]);

    useEffect(() => {
        consultarIn();
        consultarCab();
        consultarUltimosConfirmados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flag, users, cabeceraId]);

    useEffect(() => {
        if (dataEntrada.length > 0 && detalleTablaRef.current) {
            detalleTablaRef.current.scrollTo({
                top: detalleTablaRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [dataEntrada.length]);

    const getSegmentStyle = (seccion) => {
        const base = {
            background: "#ffffff",
            borderRadius: 8,
            padding: 0,
            transition: "all 0.2s ease",
            overflow: "visible",
            marginBottom: 18,
        };

        if (seccion === "CABECERA" && seccionActiva === "CABECERA") {
            return {
                ...base,
                border: "2px solid #2185d0",
                boxShadow: "0 0 0 3px rgba(33,133,208,0.08)",
            };
        }

        if (seccion === "DETALLE" && seccionActiva === "DETALLE") {
            return {
                ...base,
                border: "2px solid #f2711c",
                boxShadow: "0 0 0 3px rgba(242,113,28,0.08)",
            };
        }

        return {
            ...base,
            border: "1px solid #e5e9ef",
            boxShadow: "0 1px 3px rgba(9,30,66,0.08)",
        };
    };


    return (
        <Container
            fluid
            style={{
                maxWidth: 1400,
                padding: "24px 28px",
                margin: "0 auto",
                background: "#f8fafc",
                minHeight: "100vh",
            }}
        >
            {/* ====================================================== */}
            {/* ENCABEZADO DE PÁGINA */}
            {/* ====================================================== */}

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                    gap: 20,
                    flexWrap: "wrap",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                    }}
                >
                    <div
                        style={{
                            width: 48,
                            height: 48,
                            minWidth: 48,
                            borderRadius: 12,
                            background: "#e5f7f7",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Icon
                            name="sign-in alternate"
                            style={{
                                margin: 0,
                                color: "#0d9da5",
                                fontSize: 21,
                            }}
                        />
                    </div>

                    <div>
                        <Header
                            as="h2"
                            style={{
                                margin: 0,
                                color: "#172b4d",
                                fontSize: 24,
                                fontWeight: 700,
                            }}
                        >
                            Recepción de Equipos
                        </Header>

                        <div
                            style={{
                                color: "#8793a5",
                                fontSize: 13,
                                marginTop: 4,
                            }}
                        >
                            Ingrese equipos por compra, arriendo o comodato
                        </div>
                    </div>
                </div>

                {/* Indicador del documento actualmente cargado */}

                {confirmar && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            padding: "8px 13px",
                            background: "#ffffff",
                            border: "1px solid #dfe5ec",
                            borderRadius: 7,
                            color: "#526273",
                            fontSize: 12,
                        }}
                    >
                        <Icon
                            name="file alternate outline"
                            style={{
                                color: "#2185d0",
                                margin: 0,
                            }}
                        />

                        <span>
                            Documento en proceso:
                        </span>

                        <strong
                            style={{
                                color: "#253858",
                            }}
                        >
                            {nomTipDoc || "Documento"} N° {numDoc}
                        </strong>
                    </div>
                )}
            </div>

            {/* ====================================================== */}
            {/* CABECERA DEL DOCUMENTO */}
            {/* ====================================================== */}

            <Segment
                style={getSegmentStyle("CABECERA")}  >
                {/* CABECERA CARD */}
                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: cabeceraMinimizada
                            ? "none"
                            : "1px solid #edf0f4",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        flexWrap: "wrap",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            color: "#253858",
                            fontWeight: 600,
                        }}
                    >
                        <Icon
                            name="file alternate outline"
                            style={{
                                color: "#2185d0",
                            }}
                        />

                        Cabecera del Documento
                    </div>

                    {confirmar && (
                        <Button
                            type="button"
                            size="mini"
                            basic
                            onClick={() =>
                                setCabeceraMinimizada(!cabeceraMinimizada)
                            }
                            style={{
                                borderRadius: 6,
                                color: "#0d9da5",
                                borderColor: "#b9dfe1",
                                background: "#f7fcfc",
                                boxShadow: "none",
                            }}
                        >
                            <Icon
                                name={
                                    cabeceraMinimizada
                                        ? "angle down"
                                        : "angle up"
                                }
                                style={{
                                    color: "#0d9da5",
                                }}
                            />

                            {cabeceraMinimizada
                                ? "Ver cabecera"
                                : "Minimizar"}
                        </Button>
                    )}
                </div>

                {/* CABECERA MINIMIZADA */}

                {cabeceraMinimizada ? (
                    <div
                        style={{
                            padding: "12px 18px",
                            background: "#fbfcfd",
                            borderTop: "1px solid #edf0f4",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: 10,
                                fontSize: 12,
                                color: "#526273",
                            }}
                        >
                            <Label
                                basic
                                style={{
                                    color: "#0d9da5",
                                    borderColor: "#b9dfe1",
                                    background: "#f4fbfb",
                                }}
                            >
                                <Icon name="file" />
                                {nomTipDoc || "Documento"}
                            </Label>

                            <strong
                                style={{
                                    color: "#253858",
                                }}
                            >
                                N° {numDoc}
                            </strong>

                            <span
                                style={{
                                    color: "#8793a5",
                                }}
                            >
                                |
                            </span>

                            <span>
                                {nomTipoIn}
                            </span>

                            <span
                                style={{
                                    color: "#8793a5",
                                }}
                            >
                                |
                            </span>

                            <span>
                                {rut} - {entidad}
                            </span>
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            padding: 18,
                        }}
                    >

                        <Form
                            size="small"
                            onFocusCapture={() =>
                                setSeccionActiva("CABECERA")
                            }
                        >
                            {/* ============================================== */}
                            {/* DATOS DEL DOCUMENTO */}
                            {/* ============================================== */}

                            <div style={sectionTitleStyle}>
                                <Icon
                                    name="file outline"
                                    style={{
                                        color: "#2185d0",
                                    }}
                                />
                                Datos del documento
                            </div>

                            <Form.Group widths="equal">
                                {/* N° DOCUMENTO */}

                                <Form.Field>
                                    <label>N° de Documento</label>

                                    <Input
                                        disabled={confirmar}
                                        type="number"
                                        icon={
                                            <Icon
                                                name="hashtag"
                                                style={{
                                                    color: "#2185d0",
                                                }}
                                            />
                                        }
                                        iconPosition="left"
                                        placeholder="Ingrese N° Documento"
                                        value={numDoc}
                                        onChange={(ev) => {
                                            if (/^[1-9]\d*$/.test(ev.target.value)) {
                                                setNumDoc(ev.target.value);
                                            } else if (ev.target.value === "") {
                                                setNumDoc("");
                                            } else {
                                                mostrarError(
                                                    "Por favor ingrese un número positivo"
                                                );
                                            }
                                        }}
                                    />
                                </Form.Field>

                                {/* TIPO DOCUMENTO */}

                                <Form.Field>
                                    <label>Tipo de Documento</label>

                                    <Dropdown
                                        fluid
                                        selection
                                        disabled={confirmar}
                                        placeholder="Seleccione tipo de documento"
                                        value={nomTipDoc || ""}
                                        onChange={(e, { value }) =>
                                            setNomTipDoc(value)
                                        }
                                        options={TipDoc.map((d) => ({
                                            key: d.key,
                                            text: d.text,
                                            value: d.text,
                                        }))}
                                    />
                                </Form.Field>

                                {/* FECHA */}

                                <Form.Field>
                                    <label>Fecha Ingreso</label>

                                    <div className="ui fluid input">
                                        <DatePicker
                                            selected={date || new Date()}
                                            openToDate={date || new Date()}
                                            onChange={(fecha) => {
                                                if (!fecha) return;

                                                const ahora = new Date();

                                                fecha.setHours(
                                                    ahora.getHours(),
                                                    ahora.getMinutes(),
                                                    ahora.getSeconds(),
                                                    ahora.getMilliseconds()
                                                );

                                                setDate(new Date(fecha));
                                            }}
                                            locale={es}
                                            dateFormat="dd/MM/yyyy"
                                            todayButton="Hoy"
                                            shouldCloseOnSelect={true}
                                            placeholderText="Seleccione fecha"
                                            disabled={confirmar}
                                            minDate={fechaMinima}
                                            maxDate={fechaMaxima}
                                            wrapperClassName="datePickerFullWidth"
                                        />
                                    </div>
                                </Form.Field>
                            </Form.Group>

                            {/* ============================================== */}
                            {/* ORIGEN */}
                            {/* ============================================== */}

                            <div
                                style={{
                                    ...sectionTitleStyle,
                                    marginTop: 18,
                                }}
                            >
                                <Icon
                                    name="truck"
                                    style={{
                                        color: "#f2711c",
                                    }}
                                />
                                Origen de la recepción
                            </div>

                            <Form.Group widths="equal">
                                {/* TIPO ENTRADA */}

                                <Form.Field>
                                    <label>Tipo Entrada</label>

                                    <Dropdown
                                        fluid
                                        selection
                                        disabled={confirmar}
                                        placeholder="Seleccione tipo de entrada"
                                        value={nomTipoIn || ""}
                                        onChange={(e, { value }) =>
                                            setNomTipoIn(value)
                                        }
                                        options={TipoIn.map((d) => ({
                                            key: d.key,
                                            text: d.text,
                                            value: d.text,
                                        }))}
                                    />
                                </Form.Field>

                                {/* RUT PROVEEDOR */}

                                <Form.Field>
                                    <label>Rut Proveedor</label>

                                    <BuscadorInput
                                        items={proveedores}
                                        onSelectItem={handleSelectItem}
                                        limpiaFormCte={limpiaFormCte}
                                        confirmar={confirmar}
                                        rut={rut}
                                    />
                                </Form.Field>

                                {/* NOMBRE */}

                                <Form.Field>
                                    <label>Nombre</label>

                                    <Input
                                        value={entidad}
                                        disabled
                                        icon={
                                            <Icon
                                                name="building outline"
                                                style={{
                                                    color: "#0d9da5",
                                                }}
                                            />
                                        }
                                        iconPosition="left"
                                    />
                                </Form.Field>
                            </Form.Group>

                            {/* ============================================== */}
                            {/* INFORMACIÓN ADICIONAL */}
                            {/* ============================================== */}

                            <div
                                style={{
                                    ...sectionTitleStyle,
                                    marginTop: 18,
                                }}
                            >
                                <Icon
                                    name="info circle"
                                    style={{
                                        color: "#6435c9",
                                    }}
                                />
                                Información adicional
                            </div>

                            <Form.Field>
                                <label>Descripción</label>

                                <Form.TextArea
                                    disabled={confirmar}
                                    placeholder="Ingrese descripción o detalles adicionales a la guía"
                                    value={descripcion}
                                    onChange={(e) =>
                                        setDescripcion(e.target.value)
                                    }
                                    style={{
                                        minHeight: 70,
                                    }}
                                />
                            </Form.Field>

                            <Form.Field>
                                <label>Adjuntar Documento</label>

                                <Input
                                    ref={inputArchivoRef}
                                    type="file"
                                    accept=".pdf,image/*"
                                    disabled={confirmar}
                                    onChange={(e) =>
                                        setArchivoAdjunto(e.target.files[0])
                                    }
                                />

                                {archivoAdjunto && (
                                    <div
                                        style={{
                                            marginTop: 8,
                                            padding: "7px 10px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            background: "#f5f2fc",
                                            border: "1px solid #e1d9f4",
                                            borderRadius: 6,
                                            color: "#526273",
                                            fontSize: 12,
                                        }}
                                    >
                                        <Icon
                                            name="paperclip"
                                            style={{
                                                color: "#6435c9",
                                                margin: 0,
                                            }}
                                        />

                                        {archivoAdjunto.name}
                                    </div>
                                )}
                            </Form.Field>

                            {/* BOTONES */}

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    justifyContent: "flex-end",
                                    flexWrap: "wrap",
                                    marginTop: 18,
                                }}
                            >
                                <Button
                                    type="button"
                                    onClick={nuevo}
                                    disabled={btnNuevo}
                                    style={{
                                        borderRadius: 6,
                                        background: "#ffffff",
                                        color: "#2185d0",
                                        border: "1px solid #b9d6ee",
                                        boxShadow: "none",
                                    }}
                                >
                                    <Icon
                                        name="add"
                                        style={{
                                            color: "#2185d0",
                                        }}
                                    />
                                    Nuevo
                                </Button>

                                <Button
                                    type="button"
                                    onClick={addCabeceraIn}
                                    disabled={btnGuardar || guardandoCabecera}
                                    loading={guardandoCabecera}
                                    style={{
                                        borderRadius: 6,
                                        minWidth: 155,
                                        background: "#0d9da5",
                                        color: "#ffffff",
                                        fontWeight: 600,
                                        boxShadow: "none",
                                    }}
                                >
                                    {!guardandoCabecera && (
                                        <Icon name="save" />
                                    )}
                                    Guardar Cabecera
                                </Button>
                            </div>
                        </Form>
                    </div>
                )}
            </Segment>

            {/* ====================================================== */}
            {/* DETALLE DE EQUIPOS */}
            {/* ====================================================== */}

            <Segment
                style={{
                    ...getSegmentStyle("DETALLE"),
                    overflow: "hidden",
                }}
                onClick={() => {
                    if (confirmar) {
                        setSeccionActiva("DETALLE");
                    }
                }}
            >
                {/* HEADER */}

                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: detalleMinimizado
                            ? "none"
                            : "1px solid #edf0f4",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        flexWrap: "wrap",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            color: "#253858",
                            fontWeight: 600,
                        }}
                    >
                        <Icon
                            name="boxes"
                            style={{
                                color: "#f2711c",
                            }}
                        />

                        Detalle de Equipos

                        {dataEntrada.length > 0 && (
                            <span
                                style={{
                                    marginLeft: 6,
                                    color: "#98a1af",
                                    fontSize: 11,
                                    fontWeight: 400,
                                }}
                            >
                                {dataEntrada.length} equipo(s)
                            </span>
                        )}
                    </div>

                    {confirmar && (
                        <Button
                            type="button"
                            size="mini"
                            basic
                            onClick={() =>
                                setDetalleMinimizado(!detalleMinimizado)
                            }
                            style={{
                                borderRadius: 6,
                                color: "#0d9da5",
                                borderColor: "#b9dfe1",
                                background: "#f7fcfc",
                                boxShadow: "none",
                            }}
                        >
                            <Icon
                                name={
                                    detalleMinimizado
                                        ? "angle down"
                                        : "angle up"
                                }
                                style={{
                                    color: "#0d9da5",
                                }}
                            />

                            {detalleMinimizado
                                ? "Ver detalle"
                                : "Minimizar"}
                        </Button>
                    )}
                </div>

                {detalleMinimizado ? (
                    <div
                        style={{
                            padding: "12px 18px",
                            background: "#fbfcfd",
                            borderTop: "1px solid #edf0f4",
                        }}
                    >
                        <Label
                            basic
                            style={{
                                color:
                                    dataEntrada.length > 0
                                        ? "#21ba45"
                                        : "#8995a3",
                                borderColor:
                                    dataEntrada.length > 0
                                        ? "#b8dfc2"
                                        : "#dfe5ec",
                                background:
                                    dataEntrada.length > 0
                                        ? "#f5fbf6"
                                        : "#fafbfc",
                            }}
                        >
                            <Icon name="list" />
                            {dataEntrada.length} equipo(s) agregado(s)
                        </Label>
                    </div>
                ) : (
                    <div
                        style={{
                            padding: 18,
                        }}
                    >
                        <Form size="small">
                            <div style={sectionTitleStyle}>
                                <Icon
                                    name="barcode"
                                    style={{
                                        color: "#f2711c",
                                    }}
                                />
                                Ingreso de equipo
                            </div>

                            <Form.Group widths="equal">
                                {/* PRECIO */}

                                <Form.Field>
                                    <label>Precio</label>

                                    <Input
                                        label="$"
                                        labelPosition="left"
                                        type="text"
                                        placeholder="Ingrese Valor"
                                        value={formatearMiles(price)}
                                        disabled={btnAgregar || guardandoDetalle}
                                        onChange={(e) => {
                                            let value = limpiarNumero(e.target.value);

                                            if (value === "") {
                                                setPrice("");
                                                return;
                                            }

                                            if (/^[0-9]+$/.test(value)) {
                                                setPrice(value);
                                            }
                                        }}
                                    />

                                    {!precioValido && !btnAgregar && (
                                        <div
                                            style={{
                                                marginTop: 6,
                                                color: "#db2828",
                                                fontSize: 11,
                                            }}
                                        >
                                            <Icon
                                                name="exclamation circle"
                                                style={{
                                                    color: "#db2828",
                                                }}
                                            />
                                            Ingrese un precio para habilitar la selección
                                            de equipo.
                                        </div>
                                    )}
                                </Form.Field>

                                {/* EQUIPO */}

                                <Form.Field>
                                    <label>Equipo</label>

                                    <Input
                                        type="text"
                                        icon={
                                            <Icon
                                                name="barcode"
                                                style={{
                                                    color: "#0d9da5",
                                                }}
                                            />
                                        }
                                        iconPosition="left"
                                        placeholder="Escanee, ingrese serie/ID o seleccione desde lupa"
                                        value={numSerie}
                                        disabled={
                                            btnAgregar ||
                                            guardandoDetalle ||
                                            !precioValido
                                        }
                                        onChange={(e) =>
                                            setNumSerie(e.target.value)
                                        }
                                        onKeyDown={async (e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                await handleSubmit(e);
                                            }
                                        }}
                                    />
                                </Form.Field>

                                {/* ACCIONES */}

                                <Form.Field
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        gap: 8,
                                    }}
                                >
                                    <Button
                                        type="button"
                                        icon
                                        disabled={
                                            btnAgregar ||
                                            guardandoDetalle ||
                                            !precioValido
                                        }
                                        onClick={abrirBuscadorEquiposPreparacion}
                                        title="Buscar equipo"
                                        style={{
                                            background: "#ffffff",
                                            color: "#0d9da5",
                                            border: "1px solid #b9dfe1",
                                            borderRadius: 6,
                                            boxShadow: "none",
                                        }}
                                    >
                                        <Icon
                                            name="search"
                                            style={{
                                                color: "#0d9da5",
                                            }}
                                        />
                                    </Button>

                                    <Button
                                        type="button"
                                        icon
                                        disabled={
                                            btnAgregar ||
                                            guardandoDetalle ||
                                            !precioValido
                                        }
                                        loading={guardandoDetalle}
                                        onClick={handleSubmit}
                                        title="Agregar equipo"
                                        style={{
                                            background: "#2185d0",
                                            color: "#ffffff",
                                            borderRadius: 6,
                                            boxShadow: "none",
                                        }}
                                    >
                                        {!guardandoDetalle && (
                                            <Icon name="plus" />
                                        )}
                                    </Button>
                                </Form.Field>
                            </Form.Group>
                        </Form>

                        {/* TABLA DETALLE */}

                        <div
                            ref={detalleTablaRef}
                            style={{
                                maxHeight: 420,
                                overflowY: "auto",
                                overflowX: "auto",
                                marginTop: 12,
                                border: "1px solid #edf0f4",
                                borderRadius: 6,
                            }}
                        >
                            <Table
                                celled
                                compact
                                selectable
                                unstackable
                                style={{
                                    margin: 0,
                                    border: 0,
                                    borderRadius: 0,
                                    minWidth: 750,
                                    fontSize: 12,
                                }}
                            >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell
                                            width={1}
                                            textAlign="center"
                                            style={stickyTh}
                                        >
                                            N°
                                        </Table.HeaderCell>

                                        <Table.HeaderCell style={stickyTh}>
                                            Nombre de equipo
                                        </Table.HeaderCell>

                                        <Table.HeaderCell style={stickyTh}>
                                            N° Serie
                                        </Table.HeaderCell>

                                        <Table.HeaderCell style={stickyTh}>
                                            Precio
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            width={2}
                                            textAlign="center"
                                            style={stickyTh}
                                        >
                                            Eliminar
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {dataEntrada.length === 0 ? (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="5"
                                                textAlign="center"
                                                style={{
                                                    padding: 28,
                                                    color: "#8995a3",
                                                }}
                                            >
                                                <Icon
                                                    name="info circle"
                                                    style={{
                                                        color: "#2185d0",
                                                    }}
                                                />
                                                No hay equipos agregados al documento.
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : (
                                        dataEntrada.map((item, index) => (
                                            <Table.Row
                                                key={item.id || index}
                                                positive={
                                                    ultimoItemAgregadoId === item.eq_id
                                                }
                                            >
                                                <Table.Cell textAlign="center">
                                                    {index + 1}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    <strong
                                                        style={{
                                                            color: "#344563",
                                                        }}
                                                    >
                                                        {item.tipo +
                                                            " - " +
                                                            item.marca +
                                                            " - " +
                                                            item.modelo}
                                                    </strong>
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {item.serie}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    $
                                                    {Number(
                                                        item.price || 0
                                                    ).toLocaleString("es-CL")}
                                                    .-
                                                </Table.Cell>

                                                <Table.Cell textAlign="center">
                                                    {item.tipoinout === "COMPRA" ||
                                                        item.tipoinout === "ARRIENDO" ||
                                                        item.tipoinout === "COMODATO" ? (
                                                        <Button
                                                            type="button"
                                                            basic
                                                            icon
                                                            size="mini"
                                                            onClick={() =>
                                                                handleDelete(item.id)
                                                            }
                                                            title="Eliminar Item"
                                                            style={{
                                                                borderRadius: 6,
                                                                color: "#db2828",
                                                                borderColor: "#efc0c0",
                                                                background: "#fffafa",
                                                            }}
                                                        >
                                                            <Icon
                                                                name="trash alternate"
                                                                style={{
                                                                    color: "#db2828",
                                                                    margin: 0,
                                                                }}
                                                            />
                                                        </Button>
                                                    ) : null}
                                                </Table.Cell>
                                            </Table.Row>
                                        ))
                                    )}
                                </Table.Body>
                            </Table>
                        </div>

                        {/* TOTAL */}

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: "12px 4px 4px",
                            }}
                        >
                            <div
                                style={{
                                    padding: "9px 14px",
                                    background: "#f8fafc",
                                    border: "1px solid #e5e9ef",
                                    borderRadius: 6,
                                    color: "#344563",
                                    fontSize: 13,
                                }}
                            >
                                Total:&nbsp;
                                <strong
                                    style={{
                                        color: "#172b4d",
                                        fontSize: 15,
                                    }}
                                >
                                    $
                                    {dataEntrada
                                        .reduce(
                                            (acc, item) =>
                                                acc + Number(item.price || 0),
                                            0
                                        )
                                        .toLocaleString("es-CL")}
                                </strong>
                            </div>
                        </div>

                        {/* CONFIRMAR */}

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: 12,
                            }}
                        >
                            <Button
                                type="button"
                                onClick={() =>
                                    setShowConfirmarDocumento(true)
                                }
                                disabled={
                                    btnConfirmar ||
                                    dataEntrada.length === 0
                                }
                                loading={confirmandoDocumento}
                                style={{
                                    minWidth: 180,
                                    background: "#21ba45",
                                    color: "#ffffff",
                                    borderRadius: 6,
                                    fontWeight: 600,
                                    boxShadow: "none",
                                }}
                            >
                                {!confirmandoDocumento && (
                                    <Icon name="check" />
                                )}
                                Confirmar Documento
                            </Button>
                        </div>
                    </div>
                )}
            </Segment>

            {/* ====================================================== */}
            {/* DOCUMENTOS PENDIENTES */}
            {/* ====================================================== */}

            <Segment
                style={{
                    borderRadius: 8,
                    border: "1px solid #e5e9ef",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                    padding: 0,
                    background: "#ffffff",
                    overflow: "hidden",
                    marginBottom: 14,
                }}
            >
                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: "1px solid #edf0f4",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        color: "#253858",
                        fontWeight: 600,
                    }}
                >
                    <Icon
                        name="clipboard list"
                        style={{
                            color: "#f2711c",
                        }}
                    />

                    Documentos por Confirmar

                    <span
                        style={{
                            marginLeft: 6,
                            color: "#98a1af",
                            fontSize: 11,
                            fontWeight: 400,
                        }}
                    >
                        {cabecera.length} pendiente(s)
                    </span>
                </div>

                <div
                    style={{
                        maxHeight: 420,
                        overflowY: "auto",
                        overflowX: "auto",
                    }}
                >
                    <Table
                        celled
                        selectable
                        compact
                        unstackable
                        style={{
                            margin: 0,
                            border: 0,
                            borderRadius: 0,
                            minWidth: 1100,
                            fontSize: 12,
                            textAlign: "center",
                        }}
                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell
                                    width={1}
                                    style={stickyTh}
                                >
                                    N°
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    N° Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Fecha
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Entrada
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Rut
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Entidad
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    width={1}
                                    style={stickyTh}
                                >
                                    Cargar
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    width={1}
                                    style={stickyTh}
                                >
                                    Anular
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {cabecera.length === 0 ? (
                                <Table.Row>
                                    <Table.Cell
                                        colSpan="9"
                                        textAlign="center"
                                        style={{
                                            padding: 28,
                                            color: "#8995a3",
                                        }}
                                    >
                                        <Icon
                                            name="check circle outline"
                                            style={{
                                                color: "#21ba45",
                                            }}
                                        />
                                        No hay documentos pendientes por confirmar.
                                    </Table.Cell>
                                </Table.Row>
                            ) : (
                                cabecera.map((item, index) => (
                                    <Table.Row key={item.id}>
                                        <Table.Cell>
                                            {index + 1}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.tipdoc}
                                        </Table.Cell>

                                        <Table.Cell>
                                            <strong
                                                style={{
                                                    color: "#344563",
                                                }}
                                            >
                                                {item.numdoc}
                                            </strong>
                                        </Table.Cell>

                                        <Table.Cell>
                                            {formatearFecha(item.date)}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.tipoinout}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.rut}
                                        </Table.Cell>

                                        <Table.Cell
                                            textAlign="left"
                                        >
                                            {item.entidad}
                                        </Table.Cell>

                                        {/* CARGAR */}

                                        <Table.Cell>
                                            <Button
                                                type="button"
                                                basic
                                                icon
                                                size="mini"
                                                title="Cargar documento"
                                                onClick={() => {
                                                    setNumDoc(item.numdoc);
                                                    setNomTipDoc(item.tipdoc);
                                                    fechaDate(item.date);
                                                    setNomTipoIn(item.tipoinout);
                                                    setRut(item.rut);
                                                    setEntidad(item.entidad);
                                                    setDescripcion(
                                                        item.descripcion || ""
                                                    );
                                                    setCabeceraId(item.id);
                                                    setBtnGuardar(true);
                                                    setBtnAgregar(false);
                                                    setConfirmar(true);
                                                    setBtnNuevo(false);
                                                    setBtnConfirmar(false);

                                                    setCabeceraMinimizada(true);
                                                    setDetalleMinimizado(false);

                                                    // Documento pendiente cargado:
                                                    // trabajaremos en el detalle
                                                    setSeccionActiva("DETALLE");

                                                    setFlag((prev) => !prev);
                                                }}
                                                style={{
                                                    borderRadius: 6,
                                                    color: "#2185d0",
                                                    borderColor: "#b9d6ee",
                                                    background: "#f7fbff",
                                                }}
                                            >
                                                <Icon
                                                    name="arrow up"
                                                    style={{
                                                        color: "#2185d0",
                                                        margin: 0,
                                                    }}
                                                />
                                            </Button>
                                        </Table.Cell>

                                        {/* ANULAR */}

                                        <Table.Cell>
                                            <Button
                                                type="button"
                                                basic
                                                icon
                                                size="mini"
                                                title="Anular Documento"
                                                onClick={() =>
                                                    handleAnular(item.id)
                                                }
                                                style={{
                                                    borderRadius: 6,
                                                    color: "#db2828",
                                                    borderColor: "#efc0c0",
                                                    background: "#fffafa",
                                                }}
                                            >
                                                <Icon
                                                    name="cancel"
                                                    style={{
                                                        color: "#db2828",
                                                        margin: 0,
                                                    }}
                                                />
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            )}
                        </Table.Body>
                    </Table>
                </div>
            </Segment>

            {/* ====================================================== */}
            {/* ÚLTIMOS DOCUMENTOS CONFIRMADOS */}
            {/* ====================================================== */}

            <Segment
                style={{
                    borderRadius: 8,
                    border: "1px solid #e5e9ef",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                    padding: 0,
                    background: "#ffffff",
                    overflow: "hidden",
                    marginBottom: 14,
                }}
            >
                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: "1px solid #edf0f4",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        color: "#253858",
                        fontWeight: 600,
                    }}
                >
                    <Icon
                        name="check circle"
                        style={{
                            color: "#21ba45",
                        }}
                    />

                    Últimos Documentos Confirmados

                    <span
                        style={{
                            marginLeft: 6,
                            color: "#98a1af",
                            fontSize: 11,
                            fontWeight: 400,
                        }}
                    >
                        Últimos 5 documentos
                    </span>
                </div>

                <div
                    style={{
                        overflowX: "auto",
                    }}
                >
                    <Table
                        celled
                        selectable
                        compact
                        unstackable
                        style={{
                            margin: 0,
                            border: 0,
                            borderRadius: 0,
                            minWidth: 1100,
                            fontSize: 12,
                            textAlign: "center",
                        }}
                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell style={stickyTh}>
                                    N°
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    N° Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Fecha
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Entrada
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Rut
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Entidad
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Documentos
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {ultimosConfirmados.length === 0 ? (
                                <Table.Row>
                                    <Table.Cell
                                        colSpan="8"
                                        textAlign="center"
                                        style={{
                                            padding: 28,
                                            color: "#8995a3",
                                        }}
                                    >
                                        <Icon
                                            name="info circle"
                                            style={{
                                                color: "#2185d0",
                                            }}
                                        />
                                        No hay documentos confirmados recientemente.
                                    </Table.Cell>
                                </Table.Row>
                            ) : (
                                ultimosConfirmados.map((item, index) => (
                                    <Table.Row key={item.id}>
                                        <Table.Cell>
                                            {index + 1}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.tipdoc}
                                        </Table.Cell>

                                        <Table.Cell>
                                            <strong
                                                style={{
                                                    color: "#344563",
                                                }}
                                            >
                                                {item.numdoc}
                                            </strong>
                                        </Table.Cell>

                                        <Table.Cell>
                                            {formatearFecha(item.date)}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.tipoinout}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.rut}
                                        </Table.Cell>

                                        <Table.Cell
                                            textAlign="left"
                                        >
                                            {item.entidad}
                                        </Table.Cell>

                                        <Table.Cell>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    gap: 6,
                                                }}
                                            >
                                                {/* PDF RECEPCIÓN */}

                                                <Button
                                                    type="button"
                                                    basic
                                                    icon
                                                    size="mini"
                                                    title="Ver PDF de recepción"
                                                    loading={
                                                        cargandoPDFId === item.id
                                                    }
                                                    disabled={cargandoPDFId !== null}
                                                    onClick={() =>
                                                        verPDFDocumento(item)
                                                    }
                                                    style={{
                                                        borderRadius: 6,
                                                        color: "#db2828",
                                                        borderColor: "#efc0c0",
                                                        background: "#fffafa",
                                                    }}
                                                >
                                                    {cargandoPDFId !== item.id && (
                                                        <Icon
                                                            name="file pdf"
                                                            style={{
                                                                color: "#db2828",
                                                                margin: 0,
                                                            }}
                                                        />
                                                    )}
                                                </Button>

                                                {/* DOCUMENTO ADJUNTO */}

                                                <Button
                                                    type="button"
                                                    basic
                                                    icon
                                                    size="mini"
                                                    disabled={!item.urlAdjunto}
                                                    title={
                                                        item.urlAdjunto
                                                            ? "Ver documento adjunto"
                                                            : "Sin documento adjunto"
                                                    }
                                                    onClick={() => {
                                                        if (!item.urlAdjunto) return;

                                                        setUrlArchivoModal(
                                                            item.urlAdjunto
                                                        );

                                                        setModalArchivo(true);
                                                    }}
                                                    style={{
                                                        borderRadius: 6,
                                                        color: item.urlAdjunto
                                                            ? "#6435c9"
                                                            : "#aeb6c1",
                                                        borderColor: item.urlAdjunto
                                                            ? "#d7ccef"
                                                            : "#e1e5ea",
                                                        background: item.urlAdjunto
                                                            ? "#faf8fd"
                                                            : "#fafbfc",
                                                    }}
                                                >
                                                    <Icon
                                                        name="eye"
                                                        style={{
                                                            color: item.urlAdjunto
                                                                ? "#6435c9"
                                                                : "#aeb6c1",
                                                            margin: 0,
                                                        }}
                                                    />
                                                </Button>
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            )}
                        </Table.Body>
                    </Table>
                </div>
            </Segment>

            {/* ====================================================== */}
            {/* A PARTIR DE AQUÍ DEJA TUS MODALES ACTUALES */}
            {/* ====================================================== */}

            {modalArchivo && (
                <Overlay>

                    <ConfirmaModal
                        style={{
                            width: '90vw',
                            maxWidth: '1100px',
                            height: '85vh',
                            marginTop: '40px',
                            padding: 0,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: 12
                        }}
                    >

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 15,
                                borderBottom: '1px solid #ddd'
                            }}
                        >

                            <Header as="h3">
                                Documento Adjunto
                            </Header>

                            <Button
                                icon="close"
                                onClick={() =>
                                    setModalArchivo(false)
                                }
                            />

                        </div>

                        <div
                            style={{
                                flex: 1,
                                overflow: 'hidden'
                            }}
                        >

                            <iframe
                                src={urlArchivoModal}
                                title="Documento"
                                width="100%"
                                height="100%"
                                style={{
                                    border: 'none'
                                }}
                            />

                        </div>

                    </ConfirmaModal>

                </Overlay>
            )}

            <Alertas
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />

            {/* =====================================================
    MODAL BUSCAR EQUIPO EN PREPARACIÓN
===================================================== */}

            {modalBuscarEquipo && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "95vw",
                            maxWidth: 1000,
                            maxHeight: "88vh",
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* =================================================
                HEADER
            ================================================= */}

                        <div
                            style={{
                                padding: "16px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 15,
                                background: "#ffffff",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                }}
                            >
                                <div
                                    style={{
                                        width: 42,
                                        height: 42,
                                        minWidth: 42,
                                        borderRadius: 8,
                                        background: "#e5f7f7",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Icon
                                        name="boxes"
                                        style={{
                                            margin: 0,
                                            color: "#0d9da5",
                                            fontSize: 18,
                                        }}
                                    />
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontSize: 17,
                                            fontWeight: 700,
                                            color: "#172b4d",
                                            lineHeight: 1.25,
                                        }}
                                    >
                                        Buscar Equipo en Preparación
                                    </div>

                                    <div
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                            marginTop: 3,
                                        }}
                                    >
                                        Seleccione un equipo disponible para agregarlo
                                        a la entrada.
                                    </div>
                                </div>
                            </div>

                            <Button
                                type="button"
                                basic
                                icon
                                size="mini"
                                onClick={() => {
                                    setModalBuscarEquipo(false);
                                    setTextoFiltroEquipo("");
                                    setEquiposPreparacion([]);
                                }}
                                style={{
                                    borderRadius: 6,
                                    color: "#6b778c",
                                    boxShadow: "none",
                                }}
                            >
                                <Icon name="close" />
                            </Button>
                        </div>

                        {/* =================================================
                BÚSQUEDA
            ================================================= */}

                        <div
                            style={{
                                padding: "16px 20px",
                                borderBottom: "1px solid #edf0f4",
                                background: "#f8fafc",
                            }}
                        >
                            <Input
                                fluid
                                icon={
                                    <Icon
                                        name="search"
                                        style={{
                                            color: "#0d9da5",
                                        }}
                                    />
                                }
                                iconPosition="left"
                                placeholder="Buscar por serie, ID, tipo, marca, modelo, familia o RFID..."
                                value={textoFiltroEquipo}
                                onChange={(e) =>
                                    setTextoFiltroEquipo(e.target.value)
                                }
                                autoFocus
                            />

                            <div
                                style={{
                                    marginTop: 8,
                                    fontSize: 11,
                                    color: "#8793a5",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: 10,
                                    flexWrap: "wrap",
                                }}
                            >
                                <span>
                                    Solo se muestran equipos en estado PREPARACIÓN.
                                </span>

                                {!cargandoEquiposPrep && (
                                    <strong
                                        style={{
                                            color: "#526273",
                                        }}
                                    >
                                        {equiposPreparacionFiltrados.length} equipo(s)
                                    </strong>
                                )}
                            </div>
                        </div>

                        {/* =================================================
                TABLA
            ================================================= */}

                        <div
                            style={{
                                flex: 1,
                                minHeight: 0,
                                overflow: "auto",
                                background: "#ffffff",
                            }}
                        >
                            <Table
                                celled
                                compact="very"
                                selectable
                                unstackable
                                style={{
                                    margin: 0,
                                    border: 0,
                                    minWidth: 900,
                                }}
                            >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                            }}
                                        >
                                            Tipo
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                            }}
                                        >
                                            Marca
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                            }}
                                        >
                                            Modelo
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                            }}
                                        >
                                            Serie
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                            }}
                                        >
                                            ID
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                            }}
                                        >
                                            RFID
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            textAlign="center"
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                                width: 100,
                                            }}
                                        >
                                            Seleccionar
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {cargandoEquiposPrep ? (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="7"
                                                textAlign="center"
                                                style={{
                                                    padding: "38px 20px",
                                                    color: "#6b778c",
                                                }}
                                            >
                                                <Icon
                                                    loading
                                                    name="spinner"
                                                    style={{
                                                        color: "#0d9da5",
                                                        marginRight: 8,
                                                    }}
                                                />

                                                Cargando equipos en preparación...
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : equiposPreparacionFiltrados.length === 0 ? (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="7"
                                                textAlign="center"
                                                style={{
                                                    padding: "40px 20px",
                                                }}
                                            >
                                                <Icon
                                                    name="search"
                                                    style={{
                                                        display: "block",
                                                        margin: "0 auto 10px",
                                                        color: "#b3bac5",
                                                        fontSize: 24,
                                                    }}
                                                />

                                                <div
                                                    style={{
                                                        color: "#526273",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    No se encontraron equipos
                                                </div>

                                                <div
                                                    style={{
                                                        color: "#98a1af",
                                                        fontSize: 12,
                                                        marginTop: 4,
                                                    }}
                                                >
                                                    Intente modificar el criterio de
                                                    búsqueda.
                                                </div>
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : (
                                        equiposPreparacionFiltrados.map((eq) => (
                                            <Table.Row
                                                key={eq.id}
                                                style={{
                                                    cursor: guardandoDetalle
                                                        ? "default"
                                                        : "pointer",
                                                }}
                                                onClick={() => {
                                                    if (!guardandoDetalle) {
                                                        seleccionarEquipoPreparacion(eq);
                                                    }
                                                }}
                                            >
                                                <Table.Cell>
                                                    {eq.tipo || "-"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {eq.marca || "-"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {eq.modelo || "-"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    <strong
                                                        style={{
                                                            color: "#253858",
                                                        }}
                                                    >
                                                        {eq.serie || "-"}
                                                    </strong>
                                                </Table.Cell>

                                                <Table.Cell>
                                                    <span
                                                        style={{
                                                            color: "#6b778c",
                                                            fontSize: 12,
                                                        }}
                                                    >
                                                        {eq.id}
                                                    </span>
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {eq.rfid || "-"}
                                                </Table.Cell>

                                                <Table.Cell textAlign="center">
                                                    <Button
                                                        type="button"
                                                        size="mini"
                                                        icon
                                                        disabled={guardandoDetalle}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            seleccionarEquipoPreparacion(
                                                                eq
                                                            );
                                                        }}
                                                        style={{
                                                            background: "#0d9da5",
                                                            color: "#ffffff",
                                                            borderRadius: 6,
                                                            boxShadow: "none",
                                                        }}
                                                        title="Seleccionar equipo"
                                                    >
                                                        <Icon
                                                            name="plus"
                                                            style={{
                                                                color: "#ffffff",
                                                            }}
                                                        />
                                                    </Button>
                                                </Table.Cell>
                                            </Table.Row>
                                        ))
                                    )}
                                </Table.Body>
                            </Table>
                        </div>

                        {/* =================================================
                FOOTER
            ================================================= */}

                        <div
                            style={{
                                padding: "13px 20px",
                                borderTop: "1px solid #e5e9ef",
                                background: "#f8fafc",
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button
                                type="button"
                                basic
                                onClick={() => {
                                    setModalBuscarEquipo(false);
                                    setTextoFiltroEquipo("");
                                    setEquiposPreparacion([]);
                                }}
                            >
                                <Icon name="close" />
                                Cerrar
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}
            {/* =====================================================
    VISOR PDF DOCUMENTO DE ENTRADA
===================================================== */}

            {modalPDF && cabeceraPDF && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "96vw",
                            maxWidth: 1250,

                            // Dejamos espacio para el header superior de LogisticMed
                            height: "calc(100vh - 125px)",
                            maxHeight: 850,

                            padding: 0,
                            overflow: "hidden",

                            borderRadius: 10,
                            background: "#ffffff",

                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.24)",

                            display: "flex",
                            flexDirection: "column",

                            // Evita que el modal quede oculto bajo el navbar
                            marginTop: 70,
                        }}
                    >
                        {/* =================================================
                HEADER
            ================================================= */}

                        <div
                            style={{
                                padding: "14px 18px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 15,
                                background: "#ffffff",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                    minWidth: 0,
                                }}
                            >
                                <div
                                    style={{
                                        width: 42,
                                        height: 42,
                                        minWidth: 42,
                                        borderRadius: 8,
                                        background: "#ffebe6",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Icon
                                        name="file pdf"
                                        style={{
                                            margin: 0,
                                            color: "#db2828",
                                            fontSize: 19,
                                        }}
                                    />
                                </div>

                                <div
                                    style={{
                                        minWidth: 0,
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#172b4d",
                                            fontWeight: 700,
                                            fontSize: 17,
                                            lineHeight: 1.25,
                                        }}
                                    >
                                        Documento de Entrada
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            gap: 6,
                                            marginTop: 4,
                                            color: "#6b778c",
                                            fontSize: 12,
                                        }}
                                    >
                                        <span>
                                            {cabeceraPDF.tipdoc || "Documento"}
                                        </span>

                                        <span>•</span>

                                        <strong
                                            style={{
                                                color: "#253858",
                                            }}
                                        >
                                            N° {cabeceraPDF.numdoc}
                                        </strong>

                                        {cabeceraPDF.entidad && (
                                            <>
                                                <span>•</span>
                                                <span>
                                                    {cabeceraPDF.entidad}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <Button
                                type="button"
                                basic
                                icon
                                labelPosition="left"
                                onClick={() => {
                                    setModalPDF(false);
                                    setCabeceraPDF(null);
                                    setDetallePDF([]);
                                }}
                                style={{
                                    flexShrink: 0,
                                    borderRadius: 6,
                                    color: "#526273",
                                    borderColor: "#dfe5ec",
                                    boxShadow: "none",
                                }}
                            >
                                <Icon
                                    name="close"
                                    style={{
                                        color: "#db2828",
                                    }}
                                />
                                Cerrar
                            </Button>
                        </div>

                        {/* =================================================
                BARRA INFORMACIÓN
            ================================================= */}

                        <div
                            style={{
                                padding: "9px 18px",
                                background: "#f8fafc",
                                borderBottom: "1px solid #edf0f4",
                                display: "flex",
                                alignItems: "center",
                                gap: 16,
                                flexWrap: "wrap",
                                fontSize: 12,
                                color: "#6b778c",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5,
                                }}
                            >
                                <Icon
                                    name="calendar alternate outline"
                                    style={{
                                        color: "#2185d0",
                                        margin: 0,
                                    }}
                                />

                                <span>
                                    {formatearFecha(cabeceraPDF.date)}
                                </span>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5,
                                }}
                            >
                                <Icon
                                    name="exchange"
                                    style={{
                                        color: "#f2711c",
                                        margin: 0,
                                    }}
                                />

                                <span>
                                    {cabeceraPDF.tipoinout || "-"}
                                </span>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5,
                                }}
                            >
                                <Icon
                                    name="boxes"
                                    style={{
                                        color: "#0d9da5",
                                        margin: 0,
                                    }}
                                />

                                <span>
                                    {detallePDF.length} equipo(s)
                                </span>
                            </div>

                            {cabeceraPDF.rut && (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 5,
                                    }}
                                >
                                    <Icon
                                        name="building outline"
                                        style={{
                                            color: "#6435c9",
                                            margin: 0,
                                        }}
                                    />

                                    <span>
                                        {cabeceraPDF.rut}
                                    </span>
                                </div>
                            )}
                        </div>

                        {/* =================================================
                PDF
            ================================================= */}

                        <div
                            style={{
                                flex: 1,
                                minHeight: 0,
                                overflow: "hidden",
                                background: "#e9edf2",
                                padding: 10,
                            }}
                        >
                            <PDFViewer
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "1px solid #d7dde5",
                                    borderRadius: 7,
                                    background: "#ffffff",
                                    display: "block",
                                }}
                            >
                                <DocumentoEntradaPDF
                                    numDoc={cabeceraPDF.numdoc}
                                    nomTipDoc={cabeceraPDF.tipdoc}
                                    date={formatearFecha(cabeceraPDF.date)}
                                    nomTipoIn={cabeceraPDF.tipoinout}
                                    rut={cabeceraPDF.rut}
                                    entidad={cabeceraPDF.entidad}
                                    descripcion={cabeceraPDF.descripcion}
                                    dataEntrada={detallePDF}
                                />
                            </PDFViewer>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}
            {/* =====================================================
    MODAL ELIMINAR EQUIPO
===================================================== */}

            {showConfirmation && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 460,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#fff3eb",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name="trash alternate"
                                    style={{
                                        margin: 0,
                                        color: "#f2711c",
                                        fontSize: 18,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                        lineHeight: 1.25,
                                    }}
                                >
                                    Eliminar equipo del documento
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Se eliminará únicamente este equipo de la entrada.
                                </div>
                            </div>
                        </div>

                        {/* CONTENIDO */}
                        <div
                            style={{
                                padding: 20,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#344563",
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                ¿Desea quitar este equipo del documento de entrada?
                            </div>

                            {/* DATOS DEL EQUIPO */}
                            {(() => {
                                const equipo = dataEntrada.find(
                                    (d) => d.id === itemDelete
                                );

                                return equipo ? (
                                    <div
                                        style={{
                                            background: "#f8fafc",
                                            border: "1px solid #e5e9ef",
                                            borderRadius: 7,
                                            padding: "12px 14px",
                                            marginBottom: 16,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 12,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#6b778c",
                                                }}
                                            >
                                                Equipo
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                    fontSize: 13,
                                                    textAlign: "right",
                                                }}
                                            >
                                                {equipo.tipo || "—"}
                                            </strong>
                                        </div>

                                        <div
                                            style={{
                                                height: 1,
                                                background: "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 12,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#6b778c",
                                                }}
                                            >
                                                N° Serie
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                    fontSize: 13,
                                                }}
                                            >
                                                {equipo.serie || "—"}
                                            </strong>
                                        </div>
                                    </div>
                                ) : null;
                            })()}

                            {/* INFORMACIÓN */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    alignItems: "flex-start",
                                    background: "#f4f9fd",
                                    border: "1px solid #cce1f2",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="info circle"
                                    style={{
                                        color: "#2185d0",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    El documento permanecerá abierto y podrá seguir
                                    agregando equipos mientras no haya sido confirmado.
                                </div>
                            </div>
                        </div>

                        {/* ACCIONES */}
                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={() =>
                                    setShowConfirmation(false)
                                }
                            >
                                Cancelar
                            </Button>

                            <Button
                                color="orange"
                                type="button"
                                onClick={borrarItem}
                                icon
                                labelPosition="left"
                            >
                                <Icon name="trash alternate" />
                                Eliminar equipo
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}

            {/* =====================================================
    MODAL ANULAR DOCUMENTO
===================================================== */}

            {showConfirmationAnular && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 460,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#ffebe6",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name="exclamation triangle"
                                    style={{
                                        margin: 0,
                                        color: "#db2828",
                                        fontSize: 19,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                        lineHeight: 1.25,
                                    }}
                                >
                                    Anular documento de entrada
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Esta acción afecta al documento completo.
                                </div>
                            </div>
                        </div>

                        {/* CONTENIDO */}
                        <div
                            style={{
                                padding: 20,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#344563",
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                ¿Está seguro de que desea anular este documento de
                                entrada?
                            </div>

                            {(() => {
                                const documento = cabecera.find(
                                    (d) => d.id === itemAnular
                                );

                                return documento ? (
                                    <div
                                        style={{
                                            background: "#f8fafc",
                                            border: "1px solid #e5e9ef",
                                            borderRadius: 7,
                                            padding: "12px 14px",
                                            marginBottom: 16,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 10,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#6b778c",
                                                }}
                                            >
                                                Documento
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                }}
                                            >
                                                {documento.tipdoc || "ENTRADA"}
                                            </strong>
                                        </div>

                                        <div
                                            style={{
                                                height: 1,
                                                background: "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 10,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#6b778c",
                                                }}
                                            >
                                                N° Documento
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                }}
                                            >
                                                {documento.numdoc || "—"}
                                            </strong>
                                        </div>

                                        <div
                                            style={{
                                                height: 1,
                                                background: "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 10,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#6b778c",
                                                }}
                                            >
                                                Proveedor / Entidad
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                    textAlign: "right",
                                                }}
                                            >
                                                {documento.entidad || "—"}
                                            </strong>
                                        </div>
                                    </div>
                                ) : null;
                            })()}

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    alignItems: "flex-start",
                                    background: "#fff7f5",
                                    border: "1px solid #ffd5cc",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="warning sign"
                                    style={{
                                        color: "#db2828",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    Los equipos asociados al documento pendiente serán
                                    eliminados del detalle y la entrada quedará anulada.
                                </div>
                            </div>
                        </div>

                        {/* ACCIONES */}
                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={() =>
                                    setShowConfirmationAnular(false)
                                }
                            >
                                Cancelar
                            </Button>

                            <Button
                                negative
                                type="button"
                                onClick={anular}
                                icon
                                labelPosition="left"
                            >
                                <Icon name="ban" />
                                Anular documento
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}

            {/* =====================================================
    MODAL CONFIRMAR DOCUMENTO
===================================================== */}

            {showConfirmarDocumento && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 480,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#e9f8ef",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name="check circle"
                                    style={{
                                        margin: 0,
                                        color: "#21ba45",
                                        fontSize: 20,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                        lineHeight: 1.25,
                                    }}
                                >
                                    Confirmar documento de entrada
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Se procesará la recepción de los equipos.
                                </div>
                            </div>
                        </div>

                        {/* CONTENIDO */}
                        <div
                            style={{
                                padding: 20,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#344563",
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                ¿Desea confirmar definitivamente este documento de
                                entrada?
                            </div>

                            <div
                                style={{
                                    background: "#f8fafc",
                                    border: "1px solid #e5e9ef",
                                    borderRadius: 7,
                                    padding: "13px 14px",
                                    marginBottom: 16,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "#6b778c",
                                            fontSize: 12,
                                        }}
                                    >
                                        Equipos incluidos
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 14,
                                        }}
                                    >
                                        {dataEntrada.length}
                                    </strong>
                                </div>

                                <div
                                    style={{
                                        height: 1,
                                        background: "#e5e9ef",
                                        margin: "9px 0",
                                    }}
                                />

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "#6b778c",
                                            fontSize: 12,
                                        }}
                                    >
                                        Estado resultante
                                    </span>

                                    <Label
                                        size="tiny"
                                        style={{
                                            margin: 0,
                                            background: "#eaf4fb",
                                            color: "#2185d0",
                                            border: "1px solid #b8d7f0",
                                        }}
                                    >
                                        BODEGA
                                    </Label>
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    alignItems: "flex-start",
                                    background: "#f1faf5",
                                    border: "1px solid #ccebd8",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="info circle"
                                    style={{
                                        color: "#21ba45",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    Al confirmar, el documento quedará cerrado y los
                                    equipos serán procesados de acuerdo con el tipo de
                                    entrada registrado.
                                </div>
                            </div>
                        </div>

                        {/* ACCIONES */}
                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={() =>
                                    setShowConfirmarDocumento(false)
                                }
                            >
                                Cancelar
                            </Button>

                            <Button
                                positive
                                type="button"
                                onClick={confirmarDocumento}
                                icon
                                labelPosition="left"
                            >
                                <Icon name="check" />
                                Confirmar entrada
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}

            {cargando && <Spinner loading={cargando} mensaje="Guardando documento..." />}
        </Container>
    );
};

export default Entradas;
const sectionTitleStyle = {
    color: "#344563",
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 10,
    marginTop: 2,
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    display: "flex",
    alignItems: "center",
    gap: 4,
};

const stickyTh = {
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#f8fafc",
    color: "#344563",
    fontWeight: 600,
};